import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api/client';

const CompanyContext = createContext();

export function CompanyProvider({ children }) {
    const [companies, setCompanies] = useState([]);
    const [homeCompany, setHomeCompany] = useState(null);
    const [activeCompanyId, setActiveCompanyId] = useState(() => {
        const stored = localStorage.getItem('activeCompanyId');
        return stored ? Number(stored) : null;
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            setLoading(false);
            return;
        }

        let cancelled = false;

        api.get('/api/company/my-companies')
            .then((res) => {
                if (cancelled) return;
                const data = res.data || {};
                const list = data.companies || [];
                setCompanies(list);
                setHomeCompany(data.home_company || null);

                setActiveCompanyId((current) => {
                    if (current && list.some((c) => c.id === current)) {
                        return current;
                    }
                    // Default to the user's own company (null = act as
                    // myself), never auto-pick an invited company just
                    // because one exists.
                    return null;
                });
            })
            .catch((error) => {
                console.error('Failed to load companies:', error);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, []);

    useEffect(() => {
        if (activeCompanyId) {
            localStorage.setItem('activeCompanyId', String(activeCompanyId));
        } else {
            localStorage.removeItem('activeCompanyId');
        }
    }, [activeCompanyId]);

    const switchCompany = (companyId) => {
        setActiveCompanyId(companyId);
    };

    // Only a developer_software_company account has any notion of
    // "Individual" vs. a company - a dentist/hygienist/dental_professional
    // never has a company_id and shouldn't see this switcher at all.
    const isCompanyUser = localStorage.getItem('role') === 'developer_software_company';

    return (
        <CompanyContext.Provider value={{ companies, homeCompany, activeCompanyId, loading, switchCompany, isCompanyUser }}>
            {children}
        </CompanyContext.Provider>
    );
}

export function useCompany() {
    const context = useContext(CompanyContext);
    if (!context) {
        throw new Error('useCompany must be used within CompanyProvider');
    }
    return context;
}
